import React from 'react'
const ArrowUp = () => {
  return (
    <svg width='37' height='36' viewBox='0 0 37 36' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path id='circle' d='M36.4847 18C36.4847 8.33535 28.6443 0.5 18.9719 0.5C9.29943 0.5 1.45898 8.33535 1.45898 18C1.45898 27.6646 9.29943 35.5 18.9719 35.5C28.6443 35.5 36.4847 27.6646 36.4847 18Z' fill='#E9E9E9' stroke='#E9E9E9'/>
      <path id='arrow' d='M24.9754 20L18.9711 14L12.9668 20' stroke='black' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
    </svg>
  )
}

export default ArrowUp
